<script setup lang="ts">
  import type { PrimitiveProps } from "reka-ui";
  import type { HTMLAttributes } from "vue";
  import { Primitive } from "reka-ui";
  import { cn } from "@/lib/utils";

  const props = withDefaults(
    defineProps<
      PrimitiveProps & {
        size?: "sm" | "md";
        isActive?: boolean;
        class?: HTMLAttributes["class"];
      }
    >(),
    {
      as: "a",
      size: "md",
      class: "",
    },
  );
</script>

<template>
  <Primitive
    data-slot="sidebar-menu-sub-button"
    data-sidebar="menu-sub-button"
    :as="as"
    :as-child="asChild"
    :data-size="size"
    :data-active="isActive"
    :class="
      cn(
        'text-sidebar-foreground/80 ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-foreground flex h-6 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 outline-hidden transition-colors focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0',
        'data-[active=true]:bg-sidebar-accent data-[active=true]:font-semibold data-[active=true]:text-sidebar-foreground',
        size === 'sm' && 'text-xs',
        size === 'md' && 'text-13',
        'group-data-[collapsible=icon]:hidden',
        props.class,
      )
    ">
    <slot />
  </Primitive>
</template>
